<template>
  <el-drawer
    title="Coordinar Instalacion"
    size="70%"
    :visible.sync="drawer"
    :before-close="handleClose"
    v-loading="loadingD"
  >
    <el-container>
      <el-main>
        <el-form :model="model" ref="form">
          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-for="(d, index) in model.deviceTypes"
              :key="index"
              :title="d.title"
              :name="index"
            >
              <el-form-item label-width="0">
                <el-col>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="addNewDev(index)"
                    v-if="!hiddenAddDev[index].hidden"
                    >Agregar</el-button
                  >
                </el-col>
              </el-form-item>
              <el-row
                v-for="(d2, index2) in d.devices"
                :key="index2"
                :gutter="5"
                align="center"
                style="margin-bottom: 0 !important"
              >
                <el-col :span="5" :md="5" :xs="24" :sm="24" :lg="3">
                  <el-form-item
                    label-width="0"
                    :key="index"
                    :prop="`${index}_${index2}_technical_id`"
                    :rules="[{ validator: validateTechnical, trigger: 'blur' }]"
                  >
                    <el-select
                      v-model="d2.technical_id"
                      @change="
                        model[`${index}_${index2}_technical_id`] = $event
                      "
                      placeholder="Tecnico"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in technicians"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="5" :md="5" :xs="24" :sm="24" :lg="3">
                  <el-form-item
                    label-width="0"
                    :key="index"
                    :prop="`${index}_${index2}_model`"
                    :rules="[
                      {
                        validator: validateModel,
                        trigger: 'blur'
                      }
                    ]"
                  >
                    <el-select
                      v-model="d2.model"
                      placeholder="Modelo"
                      clearable
                      filterable
                      @change="model[`${index}_${index2}_model`] = $event"
                    >
                      <el-option
                        v-for="item in d2.model_list"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option
                    ></el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="5" :md="5" :xs="24" :sm="11" :lg="3">
                  <el-form-item
                    label-width="0"
                    :key="index"
                    :prop="`${index}_${index2}_quantity`"
                    :rules="[
                      {
                        validator: validateQuantity,
                        trigger: ['blur', 'change']
                      }
                    ]"
                  >
                    <el-input
                      type="number"
                      :min="0"
                      v-model.number="d2.quantity"
                      @change="
                        model[`${index}_${index2}_quantity`] = parseInt($event)
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="7" :md="7" :xs="24" :sm="24" :lg="14">
                  <el-form-item label-width="0" :key="index"
                    ><el-input
                      v-model="d2.comment"
                      placeholder="Comentario"
                      :key="index"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="1" :md="1" :xs="24" :sm="24" :lg="1">
                  <el-button
                    v-if="model.deviceTypes[index].devices.length > 1"
                    icon="el-icon-delete"
                    type="danger"
                    size="small"
                    @click="deleteDev(index, index2)"
                  ></el-button>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>

          <el-form-item label-width="0">
            <el-button type="primary" @click="onSubmit" size="small"
              >Guardar</el-button
            >
            <el-button type="danger" @click="drawer = false" size="small"
              >Cancelar</el-button
            >
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
// TODO: Esta accion no tiene reactividad.
import { mapActions } from "vuex";
import { formatArrayToElSelect } from "@/utils";
import { technicians } from "@/views/modules/technical_support/requests/requests";
import { COMPANYS, NAME_REQUEST_DEMO } from "@/const";

export default {
  name: "CoordinateInstallation",
  data() {
    return {
      showButton: {},
      activeNames: [0],
      drawer: false,
      model: {
        devices: [],
        deviceTypes: []
      },
      request: {},
      textLoading: "Loading",
      technicians: technicians,
      diveDict: null,
      loadingD: false
    };
  },
  methods: {
    formatArrayToElSelect,
    ...mapActions("navixy", ["searchUserId", "getModelList"]),
    ...mapActions("inventory", ["getAvailableDevices", "getAvailableSIMS"]),
    validateQuantity(rule, value, callback) {
      const { field } = rule;
      const fieldSplit = field.split("_");
      const value_original = this.model[field];

      if (!value_original) {
        return callback(new Error("Ingrese la cantidad"));
      }

      if (!Number.isInteger(value_original)) {
        callback(new Error("Ingrese dígitos"));
      } else {
        const index = parseInt(fieldSplit[0]);
        if (
          value_original > this.deviceQuantity[index].qty ||
          this.sumQuantity[index].sum > this.deviceQuantity[index].qty
        ) {
          callback(new Error("Cantidad excedida"));
        } else {
          if (this.sumQuantity[index].sum < this.deviceQuantity[index].qty) {
            callback(new Error("Falta cantidad"));
          } else {
            callback();
          }
        }
      }
    },
    validateModel(rule, value, callback) {
      const { field } = rule;
      const value_original = this.model[field];

      if (!value_original) {
        return callback(new Error("El modelo es requerido"));
      }
      callback();
    },
    validateTechnical(rule, value, callback) {
      const { field } = rule;
      const value_original = this.model[field];

      if (!value_original) {
        return callback(new Error("El tecnico es requerido"));
      }
      callback();
    },
    handleClose(done) {
      this.$refs.form.resetFields();
      done();
    },
    async show(request) {
      this.model.devices = [];
      const { ClientCode } = request.Customer;
      const { ServiceRequestType } = request;
      const { Description } = ServiceRequestType;
      const request_id = request.Id;

      const loading = this.$loading({
        lock: true,
        text: this.textLoading,
        spinner: "el-icon-loading"
      });

      try {
        let user_id;

        if (this.currentCompany === COMPANYS.MTR) {
          // si la solicitud es de tipo demo entonces no queremos
          // que valide el usuario ya que el usario navixy a usar
          // es el user demo.
          if (
            Description.toLowerCase().trim() !== NAME_REQUEST_DEMO.toLowerCase()
          ) {
            loading.text = "Veficando usuario del cliente";
            user_id = await this.searchUserId({
              client_code: ClientCode
            });

            if (user_id === -1) {
              this.$message.error(
                "El cliente atado a la solicitud no tiene usuario en Navixy"
              );
              loading.close();
              return;
            }
          }
        }

        loading.text = "Cargando solicitud";
        const request = await this.$http
          .get(`/api/serviceRequests/${request_id}/details`)
          .then(({ data }) => data);
        this.request = request;

        if (request.DeviceQuantity > 0) {
          loading.text = "Cargando lista de modelos";
          this.diveDict = await this.$http
            .get("/api/devices/typeDictionary")
            .then(({ data }) => data);

          loading.text = "Renderizando";
          this.initDevs(true);
        }

        this.drawer = true;
        loading.close();
      } catch (error) {
        console.error(error);
        this.drawer = false;
        loading.close();
      }
    },
    onSubmit() {
      this.loadingD = true;

      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.checkQuantity) {
            this.loadingD = false;
            this.$message.error(
              `Esta intentando coordinar ${this.sumQuantity} y la solicitud requiere ${this.deviceQuantity}`
            );
            return false;
          }
          const { Codes: product_code } = this.request.Product;

          const body = {
            RequestId: this.request.Id,
            UserId: this.currentUser.UserID,
            Request: this.request,
            InstallationRequests: [],
            LocationCode: product_code
          };

          for (let index = 0; index < this.model.deviceTypes.length; index++) {
            const devTypes = this.model.deviceTypes[index];
            const devs = devTypes.devices;

            for (let i2 = 0; i2 < devs.length; i2++) {
              const dev = devs[i2];

              body.InstallationRequests.push({
                TechnicianId: dev.technical_id,
                Quantity: dev.quantity,
                ServiceRequestId: this.request.Id,
                Comment: dev.comment,
                DeviceId: dev.model,
                DeviceTypeId: dev.DeviceTypeId,
                UpdatedBy: this.currentUser.UserID
              });
            }
          }

          this.$http
            .post("/api/serviceRequests/coordinateInstallation", body)
            .then((response) => {
              const { data } = response;
              const { Succeded, Message } = data;

              this.loadingD = false;
              if (Succeded === true) {
                this.drawer = false;
                this.$message.success("La operacion fue exitosa.");
                this.$emit("success");
                return;
              } else {
                this.$message.error(Message);
                return false;
              }
            })
            .catch((error) => {
              if (error.response && error.response.data) {
                const messages = JSON.parse(error.response.data.Message);
                for (let index = 0; index < messages.length; index++) {
                  const message = messages[index];
                  let self = this;
                  setTimeout(function () {
                    self.$message.error(message);
                  }, 100);
                }
              }
              this.loadingD = false;
            })
            .finally(() => {
              this.loadingD = false;
              this.drawer = false;
            });
        } else {
          this.loadingD = false;
          return false;
        }
      });
    },
    deleteDev(index, index2) {
      const masterIndex = `${index}_${index2}`;
      // Buscar la cantidad de la linea que vamos a eliminar
      const oldQuantity = this.model[`${masterIndex}_quantity`];
      // Eliminar la linea
      this.model.deviceTypes[index].devices.splice(index2, 1);
      delete this.model[`${masterIndex}_model`];
      delete this.model[`${masterIndex}_comment`];
      delete this.model[`${masterIndex}_quantity`];
      delete this.model[`${masterIndex}_technical_id`];
      // Buscar la ultima linea y sumar el valor que tenia la linea eliminada.
      this.model[`${index}_${index2 - 1}_quantity`] += oldQuantity;
      this.model.deviceTypes[index].devices[index2 - 1].quantity += oldQuantity;
    },
    initDevs() {
      let listDevTypes = [];
      for (
        let i1 = 0;
        i1 < this.request.RequestDeviceTypeQuantities.length;
        i1++
      ) {
        const rdtq = this.request.RequestDeviceTypeQuantities[i1];

        if (rdtq.Quantity === 1) {
          this.showButton[i1] = false;
        } else {
          this.showButton[i1] = true;
        }

        let devType = {
          title: `${rdtq.DeviceType.Description} (${rdtq.Quantity})`,
          devices: [],
          quantity: rdtq.Quantity,
          type: rdtq.DeviceTypeId
        };

        let flag = false;
        for (let i2 = 0; i2 < rdtq.Quantity; i2++) {
          if (!flag) {
            devType.devices.push({
              model_list: this.formatArrayToElSelect(
                this.diveDict[rdtq.DeviceTypeId],
                {
                  label: "Description"
                }
              ),
              comment: "",
              quantity: rdtq.Quantity,
              technical_id: this.request.AssignedTechnicianId,
              DeviceTypeId: rdtq.DeviceTypeId
            });

            this.model[`${i1}_${i2}_model`] = null;
            this.model[`${i1}_${i2}_comment`] = "";
            this.model[`${i1}_${i2}_quantity`] = rdtq.Quantity;
            this.model[`${i1}_${i2}_technical_id`] =
              this.request.AssignedTechnicianId;

            flag = true;
          }
        }

        listDevTypes.push(devType);
      }

      this.model.deviceTypes = listDevTypes;
    },
    addNewDev(index) {
      // TODO: Si la suma de qty al momento de agregar la nueva fila
      // es menor a la cantidad solicitada, no se debe disminuir 1
      // de la ultima fila, si no, agregar la cantidad que falta para
      // que la cantidad solicitada este completa.
      this.showButtonAddNewDev(index);

      const lenDev = this.model.deviceTypes[index].devices.length;
      const dev = this.model.deviceTypes[index].devices[lenDev - 1];

      let valorMasGrande = -1;
      let elementoMasGrande = null;

      // Buscar la linea que el quantity sea mayor que todos.
      const devs = this.model.deviceTypes[index].devices;
      for (let i in devs) {
        // const dev = this.model.devices[i];
        const quantity = this.model[`${index}_${i}_quantity`];
        if (quantity > valorMasGrande) {
          elementoMasGrande = i;
          valorMasGrande = quantity;
        }
      }

      // Le restamos 1 y se lo asignamso a la nueva linea.
      this.model.deviceTypes[index].devices[elementoMasGrande].quantity -= 1;
      this.model[`${index}_${elementoMasGrande}_quantity`] -= 1;

      // Agrega nueva linea.
      this.model[`${index}_${lenDev}_model`] = null;
      this.model[`${index}_${lenDev}_comment`] = "";
      this.model[`${index}_${lenDev}_quantity`] = 1;
      this.model[`${index}_${lenDev}_technical_id`] =
        this.request.AssignedTechnicianId;

      this.model.deviceTypes[index].devices.push({
        model_list: this.formatArrayToElSelect(
          this.diveDict[dev.DeviceTypeId],
          {
            label: "Description"
          }
        ),
        comment: "",
        quantity: 1,
        technical_id: this.request.AssignedTechnicianId,
        DeviceTypeId: dev.DeviceTypeId
      });
    },
    showButtonAddNewDev(index) {
      const sum = this.model.deviceTypes[index].devices
        .map((d) => d.quantity)
        .reduce((acc, cur) => acc + cur);
      const { Quantity } = this.request.RequestDeviceTypeQuantities[index];

      if (Quantity > sum) {
        this.showButton[index] = true;
        return true;
      }
      this.showButton[index] = false;
      return false;
    }
  },
  computed: {
    deviceQuantity() {
      return this.request.RequestDeviceTypeQuantities.map((m) => {
        return {
          type: m.DeviceTypeId,
          qty: m.Quantity
        };
      });
    },
    sumQuantity() {
      return this.model.deviceTypes.map((m) => {
        return {
          type: m.type,
          sum: m.devices
            .filter((f) => f.DeviceTypeId === m.type)
            .map((m2) => m2.quantity)
            .reduce((acc, cur) => acc + cur)
        };
      });
    },
    restQuantity() {
      return this.model.deviceTypes.map((m) => {
        return {
          type: m.type,
          rest: Math.abs(
            this.sumQuantity.find((f) => f.type === m.type).sum -
              this.deviceQuantity.find((f) => f.type === m.type).qty
          )
        };
      });
    },
    checkQuantity() {
      const sumD = this.deviceQuantity
        .map((m) => m.qty)
        .reduce((acc, cur) => acc + cur);
      const sumQ = this.sumQuantity
        .map((m) => m.sum)
        .reduce((acc, cur) => acc + cur);
      return sumD === sumQ;
    },
    hiddenAddDev() {
      return this.model.deviceTypes.map((m) => {
        const qty = this.deviceQuantity.find((f) => f.type === m.type).qty;
        const lenDevs = this.model.deviceTypes.find((f) => f.type === m.type)
          .devices.length;

        return {
          type: m.type,
          hidden: qty === lenDevs
        };
      });
    }
  }
};
</script>

<style></style>
